<template>
  <div class="home">
    <!--    <a href="https://if.geekpark.net/ticketcenter/" target="_blank">-->
    <!--      <img src="https://summit-img.geekpark.net/%E5%8D%B3%E5%88%BB%E9%94%81%E7%A5%A8.svg"-->
    <!--           style="position:fixed; width:14vh;left: 12vh;bottom: 8vh;z-index: 1000" class="ticket">-->
    <!--    </a>-->
    <Nav :visible="navVisible"></Nav>
    <div class="scroll-container-vertical" :style="{height:scrollVerticalHeight,marginLeft:scrollVerticalMarginLeft}">
      <div class="scroll-container-horizontal">
        <div class="scroll-container" :style="{transform:`translate3d(${-scrollHeight}px,0px,0px)`}">
          <main ref="scrollContainerHorizontal">
            <section>
              <Header></Header>
            </section>
            <section>
              <MeteorShower :isSafari="isSafari()"></MeteorShower>
            </section>
            <section>
              <Video></Video>
            </section>
            <section id="schedule">
              <Brief></Brief>
            </section>
            <section>
              <Schedule @updatePartners="setPartnerValue"></Schedule>
            </section>
            <section id="parallelForum">
              <ParallelForum></ParallelForum>
            </section>
            <section id="museum">
              <Museum></Museum>
            </section>
            <section id="stock-take">
              <StockTake></StockTake>
            </section>
            <section>
              <Subscribe></Subscribe>
            </section>
            <section>
              <LockTicket></LockTicket>
            </section>
            <section id="partners">
              <Partners :partner_categories="partner_categories"></Partners>
            </section>
            <section id="footer">
              <Footer></Footer>
            </section>
          </main>
        </div>
      </div>
    </div>

    <div class='video_wrapper' id='ifx_video_iframe_wrapper' style='display: none;'>
      <div class='innner_black_bg' />
      <iframe
        id='ifx_video_iframe'
        style='position: absolute; width: 100%; height: 100%; left: 0; top: 0;'
        src=''
        frameborder='no'
        scrolling='no'
      ></iframe>
      <img
        alt='关闭视频'
        class='close_video_btn'
        src='https://summit-img.geekpark.net/r2020/close_video_btn.svg'
        @click='closeVideo'
      />
    </div>

  </div>
</template>

<script>
import Nav from '@/views/HomePC/components/Nav.vue'
import Header from '@/views/HomePC/components/Header.vue'
import MeteorShower from '@/views/HomePC/components/MeteorShower.vue'
import Video from '@/views/HomePC/components/Video.vue'
import Brief from '@/views/HomePC/components/Brief.vue'
import Schedule from '@/views/HomePC/components/Schedule.vue'
import Museum from '@/views/HomePC/components/Museum.vue'
import StockTake from '@/views/HomePC/components/StockTake.vue'
import Subscribe from '@/views/HomePC/components/Subscribe.vue'
import ParallelForum from '@/views/HomePC/components/ParallelForum.vue'
import LockTicket from '@/views/HomePC/components/LockTicket.vue'
import Partners from '@/views/HomePC/components/Partners.vue'
import Footer from '@/views/HomePC/components/Footer.vue'

export default {
  name: 'HomePC',
  components: {
    Nav,
    Header,
    MeteorShower,
    Video,
    Brief,
    Schedule,
    Museum,
    StockTake,
    Subscribe,
    ParallelForum,
    LockTicket,
    Partners,
    Footer
  },
  data () {
    return {
      scrollVerticalHeight: '4000px',
      scrollVerticalMarginLeft: '0px',
      scrollHeight: 0,
      timer: null,
      navVisible: true,
      partner_categories: [
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] },
        { 'partners': [{ 'logo': { 'url': '' } }] }
      ]
    }
  },
  created () {
    this.timer = setInterval(() => {
      const images = document.querySelectorAll('img')
      for (let i = 0; i < images.length; i++) {
        if (!images[i].complete) {
          return
        }
      }
      this.setClientSize()
      clearInterval(this.timer)
    }, 10)
    window.history.scrollRestoration && (window.history.scrollRestoration = 'manual')
    window.onload = () => this.setClientSize()
    window.addEventListener('scroll', this.handleScroll, false)
    window.addEventListener('resize', this.setClientSize, false)
  },
  mounted () {
    const links = document.querySelectorAll('.navs-container > a')
    for (let i = 0, length = links.length; i < length; i++) {
      links[i].addEventListener('click', function (e) {
        const href = this.getAttribute('href')
        if (href.startsWith('#')) {
          window.scrollTo({
            'behavior': 'smooth',
            'top': document.querySelector(href).offsetLeft - document.querySelector('#nav').offsetWidth
          })
        } else {
          window.open(href, '_blank')
        }
        e.preventDefault()
        return false
      })
    }
  },
  methods: {
    isSafari () {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    },
    setClientSize () {
      const CLIENT_WIDTH = document.body.clientWidth
      const CLIENT_HEIGHT = document.body.clientHeight
      this.computeScrollVerticalHeight(CLIENT_WIDTH, CLIENT_HEIGHT)
    },
    computeScrollVerticalHeight (CLIENT_WIDTH, CLIENT_HEIGHT) {
      this.scrollVerticalHeight = this.$refs.scrollContainerHorizontal.offsetWidth - CLIENT_WIDTH + CLIENT_HEIGHT + 'px'
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollInstance = scrollHeight - this.scrollHeight
      this.scrollHeight = scrollHeight
      if (this.scrollHeight <= 0) {
        this.navVisible = true
        this.scrollVerticalMarginLeft = document.querySelector('#nav').offsetWidth + 'px'
        return
      }
      if (scrollInstance < 0) {
        this.navVisible = true
        this.scrollVerticalMarginLeft = document.querySelector('#nav').offsetWidth + 'px'
      } else {
        this.navVisible = false
        this.scrollVerticalMarginLeft = '0px'
      }
    },
    setPartnerValue (value) {
      this.partner_categories = value
    },
    closeVideo () {
      const vIframeWrapper = document.getElementById(
        'ifx_video_iframe_wrapper'
      )
      const vIframe = document.getElementById('ifx_video_iframe')
      vIframeWrapper.style.display = 'none'
      vIframe.src = ''
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.setClientSize)
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang="less">
  .home {
    position: relative;
    height: 100vh;

    .video_wrapper {
      position: fixed;
      width: 70vw;
      height: 39vw;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #000;
      z-index: 9;
      .close_video_btn {
        position: absolute;
        top: -16px;
        right: -16px;
        height: 32px;
        width: auto;
        z-index: 99;
        &:hover {
          cursor: pointer;
        }
      }
      .innner_black_bg {
        background: #000;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  .ticket {
    transition: transform .3s;

    &:hover {
      transform: scale(1.5);
    }
  }

  .scroll-container-vertical {
    overflow-scrolling: touch;
  }

  .scroll-container-horizontal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .scroll-container {
    height: 100vh;
    align-self: flex-end;
  }

  main {
    display: flex;
    position: relative;
  }

  section {
    height: 100vh;
  }
</style>
